import { render, staticRenderFns } from "./rm-summary.vue?vue&type=template&id=81373e48&scoped=true&"
import script from "./rm-summary.vue?vue&type=script&lang=js&"
export * from "./rm-summary.vue?vue&type=script&lang=js&"
import style0 from "./rm-summary.vue?vue&type=style&index=0&id=81373e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81373e48",
  null
  
)

export default component.exports